module.exports = __webpack_public_path__ + "media/images/new-user-button-e71bee0e.gif";